import SaveCapacidadCorporativa from "../../shared/componente/SavePlanesCorporativos";

export default function CreatePlanCorporativoPage() {

  return (
    <SaveCapacidadCorporativa titlePage="Crear Plan Corporativo" />
  )

}